import Button from "@mui/material/Button";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import "../App.scss";
import { PoweredBy } from "../shared/PoweredBy";
import { footerDisplaying, headerDisplaying } from "../store/mainSlice";
import { isPartnerClalit } from "../store/partnerStore";
// import WOWOrderConfirmation from "../img/WOWOrderConfirmation.png";
import WOWOrderConfirmation from "../img/svg/WOWOrderConfirmation.svg";

const OrderConfirmation = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const isClalit = useSelector(isPartnerClalit);
  let location = useLocation();
  const navigate = useNavigate();
  const [cancelTime] = useState(location.state?.cancellationTime ?? 0);

  useEffect(() => {
    dispatch(headerDisplaying(false));
    dispatch(footerDisplaying(false));
    return () => {
      dispatch(headerDisplaying(true));
      dispatch(footerDisplaying(false));
    };
  }, []);

  return (
    <div className="main-page-container relative flex-column-between">
      <div className="order-confirmation-text-wrapper">
        {!isClalit && (
          <div className="order-confirmation-img-container">
            <img src={WOWOrderConfirmation} alt="WOW Order Confirmation" />
          </div>
        )}
        <div className="order-confirmation-text-container">
          <h4>{t("CLASS_BOOKED")}</h4>
          <span style={{ display: "flex", flexDirection: "column" }}>
            <span style={{ marginLeft: "5px" }}>{t("CLASS_BOOKED_AT")} </span>
            <span>{location.state?.clubName}</span>
          </span>

          {location.state?.nowDate ? (
            <>
              <p>
                {location.state?.date} {t("ON_DATE")}
              </p>
              <p>
                {location.state?.hours}:{location.state?.minutes} {t("AT_TIME")}
              </p>
            </>
          ) : (
            <>
              <p>
                {location.state?.date.split(" ")[0]} {t("ON_DATE")}
              </p>
              <p>
                {location.state?.date.split(" ")[1]} {t("AT_TIME")}
              </p>
            </>
          )}

          {cancelTime > 0 && (
            <div className="cancel-time-container">
              <span>{t("CANCEL_TIME")}</span>
              <p>{t("CANCEL_TIME_LEFT", { hours: cancelTime })}</p>
            </div>
          )}
        </div>
      </div>
      <div>
        <Button
          variant="contained"
          className="phone-dialog-darkblue-btn select-date-time-btn-props h-50px"
          onClick={() => navigate("/orderHistory")}
          sx={{ height: "58px" }}
        >
          <div className="order-confirmation-btn">
            <p>{t("GO_TO_MY_ORDERS")}</p>
          </div>
        </Button>
        {isClalit && (
          <div>
            <PoweredBy />
          </div>
        )}
      </div>
    </div>
  );
};

export default OrderConfirmation;
